import { forwardRef } from "react";

export type AuthErrorSummaryItem = {
  id: string;
  message: string;
};

type AuthErrorSummaryProps = {
  titleId: string;
  title: string;
  items: AuthErrorSummaryItem[];
};

export const AuthErrorSummary = forwardRef<HTMLDivElement, AuthErrorSummaryProps>(
  ({ titleId, title, items }, ref) => (
    <div
      ref={ref}
      role="alert"
      aria-labelledby={titleId}
      tabIndex={-1}
      className="rounded-md border border-red-600 bg-red-500/10 p-4 dark:border-red-400"
    >
      <h2
        id={titleId}
        className="mb-2 text-sm font-semibold text-red-600 dark:text-red-400"
      >
        {title}
      </h2>
      <ul className="space-y-1">
        {items.map((item) => (
          <li key={item.id}>
            <button
              type="button"
              onClick={() => document.getElementById(item.id)?.focus()}
              className="inline-flex min-h-[44px] items-center py-2 text-left text-sm text-red-600 underline dark:text-red-400"
            >
              {item.message}
            </button>
          </li>
        ))}
      </ul>
    </div>
  ),
);

AuthErrorSummary.displayName = "AuthErrorSummary";
